import { APIPrefix } from '@/enums/api.enum';
import { ApiFetcher } from '@/utils/api-service';
import { Editor, FileLoader } from 'ckeditor5';
import { ErrorUploadImage } from './ErrorUploadImage';

class MyUploadAdapter {
  loader: FileLoader;
  abortController?: AbortController;

  constructor(loader: FileLoader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    return this.loader.file.then(async (file) => {
      const apiFetcher = new ApiFetcher(
        currentCtx.appEnv.apiHost,
        APIPrefix.Admin
      );

      const abortController = this.createAbortSignal();

      try {
        const imageBase64 = await this._toBase64(file);

        if (!imageBase64) {
          throw new ErrorUploadImage(file);
        }

        const dataResponse = await apiFetcher.post(
          'upload-image',
          { thumbnail: imageBase64 },
          {
            signal: abortController.signal,
            onUploadProgress: (evt) => {
              this.loader.uploadTotal = evt.total || null;
              this.loader.uploaded = evt.loaded;
            }
          }
        );

        if (dataResponse?.status === 200) {
          const convertImage = await apiFetcher.post(`convert-image-url`, {
            imageUrl: dataResponse.data
          });
          if (convertImage?.status === 200) {
            return {
              default: convertImage.data
            };
          }
        }

        throw new ErrorUploadImage(file);
      } catch (e) {
        console.log(e);

        throw new ErrorUploadImage(file);
      }
    });
  }

  createAbortSignal() {
    const abortController = new AbortController();

    this.abortController = abortController;

    setTimeout(() => {
      abortController.abort();
    }, 30000);

    return abortController;
  }

  // Aborts the upload process.
  abort() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  _toBase64 = (file: File | null) =>
    file
      ? new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      })
      : undefined;
}

export function MyCustomUploadAdapterPlugin(editor: Editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    // Configure the URL to the upload script in your back-end here!
    return new MyUploadAdapter(loader);
  };
}
